import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  Card,
  CardBody,
  Input,
  Button,
  Row,
  Col,
  Spinner,
  CardHeader,
  Alert
} from "reactstrap";
import api from "../../services/api";
import { useParams } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import "./invoice.css";

const StudentPaymentCard = () => {
  const navigate = useNavigate();
  const { course_id, technology_id } = useParams();
  const backendUrl = process.env.REACT_APP_BACKEND_URL;
  const [rollNo, setRollNo] = useState("");
  const [studentData, setStudentData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [paymentLoading, setPaymentLoading] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");
  const [allTermsPaid, setAllTermsPaid] = useState("");
  const [remarks, setRemarks] = useState("");
  const [user, setUser] = useState();
  const [backToCourses, setBackToCourses] = useState(false);

  useEffect(() => {
    let authUser = JSON.parse(localStorage.getItem('authUser'));
    setUser(authUser)
    // console.log(authUser)
  }, [])

  // Fetch student details
  const handleFetchStudent = async () => {
    setAllTermsPaid("");
    if (!rollNo.trim()) {
      setErrorMsg("Please enter Roll No");
      return;
    }

    setErrorMsg("");
    setLoading(true);
    setStudentData(null);

    try {
      const res = await api.post(`${backendUrl}get-fee-payments-by-rollno`, {
        roll_no: rollNo.toUpperCase().trim(),
        course: course_id,
        technology: technology_id,
      }, );
      if (res.data.success && Array.isArray(res.data.data) && res.data.data.length > 0) {
        setStudentData(res.data.data[0]);
        // console.log(res.data.data[0])
      } else if (res.data.message) {
        setAllTermsPaid(res.data.message);
        setBackToCourses(true);
      } else {
        setErrorMsg("No data found for the given details.");
      }
    } catch (err) {
      if (err.response?.data?.message)
        setErrorMsg(err.response.data.message);
      setBackToCourses(true);
    } finally {
      setLoading(false);
    }
  };

  // Format date to IST
  const formatISTDate = (isoDate) => {
    const options = {
      timeZone: "Asia/Kolkata",
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    };
    return new Date(isoDate)
      .toLocaleString("en-IN", options)
      .replace(",", "")
      .replaceAll("/", "-");
  };

  // Generate and open invoice PDF
  const generateInvoicePDF = async (payment_data) => {
    return new Promise(async (resolve) => {
      const {
        trainee_roll_no,
        trainee_name,
        trainee_branch,
        trainee_college,
        trainee_passout_year,
        name_of_the_track,
        name_of_the_course,
        amount_paid,
        the_term,
        payment_id,
        payment_date,
        cashier_name
      } = payment_data;

      // Create hidden invoice element
      const invoiceDiv = document.createElement("div");
      invoiceDiv.className = "invoice-container";
      invoiceDiv.style.position = "absolute";
      invoiceDiv.style.left = "-9999px";
      invoiceDiv.innerHTML = `
      <div class="overlay">
        <h1 class="payment-id">No.${payment_id}</h1>
        <h1 class="payment-date text-uppercase">${payment_date}</h1>
        <h2 class="trainee-name">${trainee_name}</h2>
        <h2 class="trainee-roll-no">${trainee_roll_no}</h2>
        <h2 class="trainee-branch">${trainee_branch}</h2>
        <h2 class="trainee-passout">${trainee_passout_year}</h2>
        <h2 class="trainee-college">${trainee_college}</h2>
        <h2 class="name-of-the-track">${name_of_the_course}</h2>
        <h2 class="name-of-the-course">${name_of_the_track}</h2>
        <h2 class="amount-paid">${amount_paid}</h2>
        <h2 class="the-term">${the_term}</h2>
        <h2 class="cashier-name-1">${cashier_name}</h2>

        <h1 class="payment-id-1">No.${payment_id}</h1>
        <h1 class="payment-date-1 text-uppercase">${payment_date}</h1>
        <h2 class="trainee-name-1">${trainee_name}</h2>
        <h2 class="trainee-roll-no-1">${trainee_roll_no}</h2>
        <h2 class="trainee-branch-1">${trainee_branch}</h2>
        <h2 class="trainee-passout-1">${trainee_passout_year}</h2>
        <h2 class="trainee-college-1">${trainee_college}</h2>
        <h2 class="name-of-the-track-1">${name_of_the_course}</h2>
        <h2 class="name-of-the-course-1">${name_of_the_track}</h2>
        <h2 class="amount-paid-1">${amount_paid}</h2>
        <h2 class="the-term-1">${the_term}</h2>
        <h2 class="cashier-name">${cashier_name}</h2>
      </div>
    `;

      document.body.appendChild(invoiceDiv);

      const canvas = await html2canvas(invoiceDiv, { scale: 2, useCORS: true });
      const imgData = canvas.toDataURL("image/png");
      const pdf = new jsPDF("p", "mm", "a4");
      const pageWidth = pdf.internal.pageSize.getWidth();
      const imgHeight = (canvas.height * pageWidth) / canvas.width;

      pdf.addImage(imgData, "PNG", 0, 0, pageWidth, imgHeight);

      const pdfBlob = pdf.output("blob");
      const pdfUrl = URL.createObjectURL(pdfBlob);

      window.open(pdfUrl, "_blank");

      document.body.removeChild(invoiceDiv);

      // Let browser finish opening tab
      setTimeout(() => resolve(), 200);
    });
  };


  // console.log(user)
  // Make payment
  const handleMakePayment = async () => {
    if (!studentData) {
      toast.error("No student data found.");
      return;
    }

    const paymentData = {
      roll_no: studentData.roll_no,
      reg_id: studentData.reg_id,
      term_name: studentData.term_name,
      course_id: studentData.course_id,
      technology_id: studentData.technology_id,
      amount: studentData.final_amount,
      cash_counter_name: user?.college,
      cashier_name: user?.first_name,
      discount: studentData.discount_amount || "0",
      remarks: remarks || "",
    };

    // console.log(paymentData)


    setPaymentLoading(true);

    try {

      const res = await api.post(`${backendUrl}create-fee-payment`, paymentData,
    );
      if (res.status === 201) {
        toast.success("Payment successfully created!");
        const isoDate = res.data.paymentRecord.payment_details.slice(-1)[0].created_at;
        const formatted_date = formatISTDate(isoDate);

        const payment_data = {
          cashier_name: user?.first_name,
          payment_id: res.data.paymentRecord.payment_details.slice(-1)[0].payment_id,
          trainee_name: studentData.first_name,
          trainee_roll_no: studentData.roll_no,
          trainee_branch: studentData.branch.join(", "),
          trainee_college: studentData.college,
          trainee_passout_year: studentData.passout_year,
          name_of_the_track: studentData.technology_name,
          name_of_the_course: studentData.course_name,
          amount_paid: studentData.final_amount,
          the_term: studentData.term_name,
          payment_date: formatted_date,
        };

        await generateInvoicePDF(payment_data);

        setTimeout(() => {
          navigate("/course-payments");
        }, 300);

      } else {
        toast.error(res.data.err || "Failed to create payment.");
      }
    } catch (err) {
      if (err.response?.status === 400) {
        toast.error(err.response.data.message || "Error creating payment.");
      } else {
        toast.error("Error creating payment. Please try again.");
      }
    } finally {
      setPaymentLoading(false);
    }
  };

  return (
    <div className="mt-4">
      <ToastContainer position="top-right" autoClose={3000} />

      <Card className="shadow-sm border-0 mb-4" style={{ borderRadius: "12px" }}>
        <CardBody>
          <Row className="align-items-end g-3">
            <Col md={3} sm={6} xs={12}>
              <label className="fw-semibold mb-1">Roll Number</label>
              <Input
                type="text"
                value={rollNo}
                onChange={(e) => setRollNo(e.target.value)}

                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    handleFetchStudent();
                    return;
                  }
                  const allowedKeys = [
                    "Backspace",
                    "Tab",
                    "Enter",
                    "ArrowLeft",
                    "ArrowRight",
                    "Delete",
                  ];

                  // Allow navigation keys
                  if (allowedKeys.includes(e.key)) return;

                  // Allow Ctrl + A, Ctrl + C, Ctrl + V (optional, remove if not needed)
                  if ((e.ctrlKey || e.metaKey) && ["a", "c", "v"].includes(e.key.toLowerCase()))
                    return;

                  // BLOCK every key that is NOT a-z / A-Z / 0-9
                 if (!/^[a-zA-Z0-9-]$/.test(e.key)) {
                e.preventDefault();
            }
                }}
                placeholder="Enter Student Roll No"
                autoFocus
                bsSize="md"
              />

            </Col>
            <Col md={1} sm={6} xs={12}>
              <Button
                color="primary"
                onClick={handleFetchStudent}
                className="w-100 fw-semibold"
                disabled={loading}
                size="md"
              >
                {loading ? <Spinner size="sm" /> : "GET Details"}
              </Button>
            </Col>
            {
              backToCourses && (
                <Col md={2} sm={6} xs={12} className="ms-auto">
                  <Button
                    color="#6c757d"
                    onClick={() => navigate("/course-payments")}
                    className="w-100 fw-semibold border border-2"
                    size="md"
                  >
                    Back to Courses
                  </Button>
                </Col>
              )
            }
          </Row>

          {errorMsg && <Alert color="danger" className="mt-3 mb-0">{errorMsg}</Alert>}
          {allTermsPaid && <Alert color="success" className="mt-3 mb-0">{allTermsPaid}</Alert>}
        </CardBody>
      </Card>

      {studentData && (
        <Row className="g-4">
          {/* STUDENT DETAILS */}
          <Col lg={7} md={12}>
            <Card className="shadow-sm border-0" style={{ borderRadius: "12px" }}>
              <CardHeader className="bg-light border-0">
                <h5 className="fw-bold mb-0">Student Details</h5>
              </CardHeader>
              <CardBody className="py-2">
                <Row className="mb-3 border border-1 py-2"><Col sm={4}>Name</Col><Col sm={8}>{studentData.first_name}</Col></Row>
                <Row className="mb-3 border border-1 py-2"><Col sm={4}>Roll Number</Col><Col sm={8}>{studentData.roll_no}</Col></Row>
                <Row className="mb-3 border border-1 py-2"><Col sm={4}>College</Col><Col sm={8}>{studentData.college}</Col></Row>
                <Row className="mb-3 border border-1 py-2"><Col sm={4}>Branch</Col><Col sm={8}>{studentData.branch.join(", ")}</Col></Row>
                <Row className="mb-3 border border-1 py-2"><Col sm={4}>Program</Col><Col sm={8}>{studentData.program_name}</Col></Row>
                <Row className="mb-3 border border-1 py-2"><Col sm={4}>Technology</Col><Col sm={8}>{studentData.technology_name}</Col></Row>
                <Row className="mb-3 border border-1 py-2"><Col sm={4}>Term</Col><Col sm={8}>{studentData.term_name}</Col></Row>
              </CardBody>
            </Card>
          </Col>

          {/* PAYMENT ACTION */}
          <Col lg={5} md={12}>
            <Card className="shadow-sm border-primary border-2 py-1" style={{ borderRadius: "12px" }}>
              <CardHeader className="bg-primary bg-opacity-10 border-0">
                <h5 className="fw-bold mb-0 text-primary">Payment Action</h5>
              </CardHeader>
              <CardBody className="text-center">
                <h6 className="text-muted">FINAL AMOUNT</h6>
                <h1 className="fw-bolder text-success display-5 mb-3">₹{studentData.final_amount}</h1>

                <div className="text-start bg-light p-3 rounded mb-3">
                  <Row>
                    <Col className="text-muted fs-5">Term Amount:</Col>
                    <Col className="text-end fw-semibold fs-3">₹{studentData.original_amount}</Col>
                  </Row>
                  <Row>
                    <Col className="text-muted fs-5">Term Discount:</Col>
                    <Col className="text-end fw-semibold text-danger fs-3">
                      - ₹{studentData.discount_amount}
                    </Col>
                  </Row>
                </div>

                <Input
                  type="textarea"
                  rows="3"
                  placeholder="Enter payment remarks (optional)..."
                  value={remarks}
                  onChange={(e) => setRemarks(e.target.value)}
                  className="mb-3"
                  style={{ resize: "none", overflowY: "auto" }}
                />


                <Button
                  color="success"
                  className="fw-bold w-100"
                  size="lg"
                  onClick={handleMakePayment}
                  disabled={paymentLoading}
                >
                  {paymentLoading ? <Spinner size="sm" /> : "Confirm & Make Payment"}
                </Button>
              </CardBody>
            </Card>
          </Col>
        </Row>
      )}
    </div>
  );
};

export default StudentPaymentCard;
